export default __webpack_public_path__ + "static/media/editImageIcon.6b1591f1.svg";